import { createFileRoute, redirect } from '@tanstack/react-router';
export const Route = createFileRoute('/_staff/equipment/items/$id/_detail/')({
  beforeLoad: ({
    params
  }) => {
    throw redirect({
      to: '/equipment/items/$id/inventory',
      params: {
        id: params.id
      }
    });
  }
});